var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-cell-task-name-edit"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":_vm.editTaskName}},[_c('span',[_vm._v(_vm._s(_vm.$t('Edit')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }